module.exports = __webpack_public_path__ + "img/logout.7359572f.svg";